// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2TwNf","image":"Header_image__32f2T","name":"Header_name__1oxPf","info":"Header_info__1-4f0","infoRow":"Header_infoRow__1yOfy"};